<script setup lang="ts">

import {SearchResultOrder} from "@/components/QuickSearch/search-types";
import {CurrencyDisplay, formatting, useEnums} from "@hantera/portal-app";

const props = defineProps<{
  result: SearchResultOrder
}>();

const enums = useEnums();

const channelValue = enums.value('order', 'channelKey', props.result.data.channelKey)

const tagValues = props.result.data.tags.map(t => {
  return enums.value('order', 'tags', t).value ?? {
    key: t,
    label: t
  }
})

</script>

<template>
  <div
    class="order-result"
  >
    <div
      class="order-result__state"
      :style="`background-color: var(--state-colors__order-${result.data.orderState})`"
      :title="result.data.orderState"
    ></div>
    
    <div class="order-result__order-number">
      {{ result.data.orderNumber }}
    </div>
    <div
      class="order-result__channel-key"
      :class="{
        'has-hue': !!channelValue?.hue
      }"
      :style="!!channelValue?.hue ? `--color-hue: ${channelValue.hue}` : ''"
    >
      {{ result.data.channelKey }}
    </div>
    <div class="order-result__created-at">

      {{ formatting.date(result.data.createdAt) }}
    </div>

    <div
      class="order-result__order-tags"
    >
      <div
        v-for="tag in tagValues"
        :key="tag.key"
        class="order-result__tag"
        :class="{
          'has-hue': tag.hue !== undefined
        }"
        :style="tag.hue ? `--color-hue: ${tag.hue}` : ''"
      ></div>

    </div>
    <div class="order-result__order-total">
      {{ formatting.currency(result.data.orderTotal, result.data.currencyCode, CurrencyDisplay.code) }}
    </div>

  </div>
</template>

<style scoped>

.order-result {
  display: grid;
  grid-template-columns: repeat(4, min-content) 1fr min-content;
  position: relative;
  white-space: nowrap;
  gap: 5px;
  align-items: center;
}

.order-result__state {
  width: 5px;
  height: 16px;
  border-radius: 5px
}

.order-result__channel-key {
  border-radius: 4px;
  padding: 0 3px;

  --color-lightness: var(--color-60-l);
  color: hsl(var(--color-text));
  background-color: hsl(var(--color-hue), var(--color-saturation), var(--color-lightness));
}

.has-hue {
  --color-saturation: 116.08%;
  --color-lightness: 36.74%;
  --color-text: 0, 100%, 100%;
}

.order-result__order-tags {
  display: flex;
  gap: 5px;
  align-items: center;
}

.order-result__tag {
  border-radius: 4px;
  width: 10px;
  height: 10px;

  --color-lightness: var(--color-60-l);
  color: hsl(var(--color-text));
  background-color: hsl(var(--color-hue), var(--color-saturation), var(--color-lightness));
}

.order-result__created-at,
.order-result__order-total {
  color: hsl(var(--color-40));
}

</style>